/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { Result } from "../../../../graphql/__GENERATED__/types";
import QuotationCard from "./QuotationCard";

interface QuotationCardListProps {
  results: Result[];
  activeCards: string[];
  showOrderNumbers?: boolean;
  editing: boolean;
  allowEdition?: boolean;
  onClick: (id: string) => void;
  handleEdit?: (id: string) => any;
  handleDelete?: (id: string) => any;
}

const styles = {
  cardList: {
    display: "flex",
    flexWrap: "wrap" as "wrap",
  },
};

const QuotationCardList: FC<QuotationCardListProps> = ({
  results,
  activeCards,
  showOrderNumbers,
  editing,
  allowEdition,
  onClick,
  handleEdit,
  handleDelete,
}) => {
  return (
    <div css={styles.cardList}>
      {results.map((result, i) => (
        <QuotationCard
          key={`quotationCard-${i}`}
          result={result}
          active={activeCards.includes(result._id!)}
          order={
            showOrderNumbers ? activeCards.indexOf(result._id!) + 1 : undefined
          }
          allowEdition={allowEdition}
          editing={editing}
          onClick={() => onClick(result._id!)}
          onEdit={() => handleEdit && handleEdit(result._id!)}
          onRemove={() => handleDelete && handleDelete(result._id!)}
        />
      ))}
    </div>
  );
};

export default QuotationCardList;
